import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Wrapper from '../layouts/Wrapper';
// import SectionsInfo from '../components/SectionsInfo';
import useWindowSize from '../hooks/useWindowSize';
import BannerTemplate from '../components/BannerTemplate';
import Spinner from '../components/Spinner';
import { getPartnersPage } from '../store/actions/partnersPage';

function PartnerCard({ name, img, href }) {
  const { width } = useWindowSize();
  return (
    <a href={href} target="_blank" className="partner__list-card" rel="noreferrer">
      <div className="partner__list-card-image">
        <img src={img} alt="" />
      </div>
      {width > 768 && <p>{name}</p>}
    </a>
  );
}

function Partners() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { translations, loading: translationsLoading } = useSelector((state) => state.translation);
  useEffect(() => {
    dispatch(getPartnersPage());
  }, []);
  const { loading, data } = useSelector((state) => state.partnersPage);
  return (
    <Wrapper>
      {!loading && !translationsLoading ? (
        <div className="container small">
          <BannerTemplate
            bgImage={data?.partners?.image?.webp_url}
            title={data.partners.title[lang]}
            description={data.partners.content_title[lang]}
          />
          <div className="partners_list-content ">
            {/* <SectionsInfo */}
            {/*  isSlider={false} */}
            {/*  isPartner={false} */}
            {/*  title="Partnering with Leading Medical Providers" */}
            {/*  description="We partner with top medical centers and clinics across */}
            {/* Armenia to provide
            comprehensive diagnostic services for health-conscious patients." */}
            {/* /> */}
            <div className="partners_list-content_row">
              <div>
                <h2>{translations.partner_collaboration?.[lang] || ''}</h2>
                <div className="partners_list">
                  {data.partners.data.filter((e) => e.type === 'collaboration_partner').map((e) => (
                    <PartnerCard
                      key={e.id}
                      href={e.url}
                      img={e?.image?.webp_url}
                      name={e.title ? e.title[lang] : ''}
                    />
                  ))}
                </div>
              </div>
              <div>
                <h2>{translations.partner_supplier?.[lang]}</h2>
                <div className="partners_list">
                  {data.partners.data.filter((e) => e.type === 'supplier').map((e) => (
                    <PartnerCard
                      key={e.id}
                      href={e.url}
                      img={e?.image?.webp_url}
                      name={e.title ? e.title[lang] : ''}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Partners;
